import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=ad554a98"
import script from "./TaskPage.vue?vue&type=script&lang=js"
export * from "./TaskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports